import { useInView } from 'react-intersection-observer';
import { useEffect, useState } from 'react';

const FlowerTitle = ({text}) => {

  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce: true
  });


  const [stroke, setStroke] = useState(false);


  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setStroke(true);
    };
    img.src = `${process.env.PUBLIC_URL}/img/bg.webp`;
  }, []);

  return (
    <div className={`flower-title ${inView && stroke && "flower-visible"}`} ref={ref}>
      <h2 className="title-text">{text}</h2>
      <div className="flowers">
        <img src={`${process.env.PUBLIC_URL}/img/ui/deco1.png`} alt="Flower 1" className='flower-1'/>
        <img src={`${process.env.PUBLIC_URL}/img/ui/deco2.png`} alt="Flower 2" className='flower-2'/>
        <img src={`${process.env.PUBLIC_URL}/img/ui/deco3.png`} alt="Flower 3" className='flower-3'/>
      </div>
    </div>
  )
}

export default FlowerTitle;